<!-- Page content -->
<div class="container mt-8 pb-5">
  <!-- Table -->
  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-8">
      <div class="card">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <img src="assets/img/brand/logo.png" style="max-width: 300px;" class="mb-4 w-100" />
            <h1>Inscription</h1>
          </div>
          <div class="w-100" *ngIf="step == 'mode'">
            <button type="submit" class="btn btn-outline-studiomap w-100" (click)="to_form('email')"><i
                style="font-size: large !important;" class="ni ni-email-83 float-left"></i>S'inscrire avec
              email et mot de passe</button>
            <!-- social media -->
            <button class="btn btn-outline-studiomap my-3 w-100" type="submit" (click)="to_form('facebook')">
              <img class="float-left" width="23" src="assets/img/facebook.webp" alt="facebook"> <span>S'inscrire avec
                facebook </span>
            </button>
            <button class="btn btn-outline-studiomap w-100" type="submit" (click)="to_form('google')">
              <img class="float-left" width="23" src="assets/img/google.webp" alt="mail"> <span>S'inscrire avec google
              </span>
            </button>
            <button class="btn btn-outline-studiomap w-100 mt-3" type="button" (click)="to_form('phone')">
              <i class="fa fa-phone fa-lg float-left"></i> <span>S'inscrire avec numéro téléphone </span>
            </button>
          </div>
          <div *ngIf="step == 'form'">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="d-flex input-group-alternative mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-venus-mars"></i></span>
                </div>
                <div class="p-2">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input formControlName="title" type="radio" id="monsieur" value="monsieur"
                      class="custom-control-input">
                    <label class="custom-control-label" for="monsieur">Monsieur</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input formControlName="title" type="radio" id="madame" value="madame" class="custom-control-input">
                    <label class="custom-control-label" for="madame">Madame</label>
                  </div>
                </div>
              </div>
              <div class="d-flex input-group-alternative mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-address-book"></i></span>
                </div>
                <div class="p-2 w-100">
                  <select formControlName="role" class="form-control border" aria-label="role">
                    <option value="artist">Artiste</option>
                    <option value="manager_studio">Gérant</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group input-group-alternative mb-3">
                  <div class="input-group-prepend">
                    <span [ngClass]="{'icon-border-error':formControl.full_name.errors && submitted}"
                      class="input-group-text"><i class="ni ni-hat-3"></i></span>
                  </div>
                  <input [ngClass]="{'input-border-error':formControl.full_name.errors && submitted}"
                    formControlName="full_name" class="form-control" placeholder="Nom et prénom" type="text">
                </div>
              </div>
              <div class="form-group" *ngIf="provider == 'email' || provider == 'phone'">
                <div class="input-group input-group-alternative mb-3">
                  <div class="input-group-prepend">
                    <span [ngClass]="{'icon-border-error':formControl.email.errors && submitted}"
                      class="input-group-text"><i class="ni ni-email-83"></i></span>
                  </div>
                  <input [ngClass]="{'input-border-error':formControl.email.errors && submitted}"
                    formControlName="email" class="form-control" placeholder="Email" type="email">
                </div>
              </div>
              <div class="form-group">
                <input [ngClass]="{'input-border-error':formControl.phone.errors && submitted}" formControlName="phone"
                  type="text" id="phone" class="form-control form-control-alternative" placeholder="Téléphone">
              </div>
              <div class="form-group" *ngIf="provider == 'email'">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span [ngClass]="{'icon-border-error':formControl.password.errors && submitted}"
                      class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                  </div>
                  <input [ngClass]="{'input-border-error':formControl.password.errors && submitted}"
                    formControlName="password" class="form-control" placeholder="Mot de passe" type="password">
                </div>
              </div>
              <div class="form-group" *ngIf="provider == 'email'">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span [ngClass]="{'icon-border-error':formControl.confirmPassword.errors && submitted}"
                      class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                  </div>
                  <input [ngClass]="{'input-border-error':formControl.confirmPassword.errors && submitted}"
                    formControlName="confirmPassword" class="form-control" placeholder="Confirmer votre mot de passe"
                    type="password">
                </div>
              </div>

              <div class="row my-4">
                <div class="col-12">
                  <div class="custom-control custom-control-alternative custom-checkbox">
                    <input [ngClass]="{'border-danger':formControl.cgu.errors && submitted}" formControlName="cgu"
                      class="custom-control-input" id="cgu" type="checkbox">
                    <label class="custom-control-label" for="cgu">
                      <span class="text-muted">Je reconnais avoir lu et accepté <a href="javascript:void(0)" (click)="navigateTo('cguv-user')">les conditions générales
                          d'utilisation</a></span>
                    </label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="custom-control custom-control-alternative custom-checkbox">
                    <input [ngClass]="{'border-danger':formControl.charte.errors && submitted}" formControlName="charte"
                      class="custom-control-input" id="charte" type="checkbox">
                    <label class="custom-control-label" for="charte">
                      <span class="text-muted">J'ai lu et m'engage à respecter <a href="javascript:void(0)" (click)="navigateTo('charte-studiomap')">la charte
                          STUDIOMAP</a></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-studiomap mt-4 w-100"><i
                    class="fa fa-check mr-2"></i>Valider</button>
                <button (click)="back()" class="btn btn-outline-studiomap mt-2 w-100"><i class="fa fa-angle-left"></i>
                  Retour</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-center pointer"><a href="javascript:void(0)" (click)="navigateTo('login')"
            class="text-dark"><small>Connexion</small></a></div>
      </div>
    </div>
  </div>
</div>